import {
  PANEL,
  PANEL_BORDER,
  PANEL_PAGE_BG,
  PANEL_SURFACE,
} from "./panelTokens";

export { PANEL_PAGE_BG, PANEL_SURFACE, PANEL_BORDER };

/** Geriye uyumluluk — tenant export isimleri */
export const TENANT_PAGE_BG = PANEL_PAGE_BG;
export const TENANT_SURFACE = PANEL_SURFACE;
export const TENANT_BORDER = PANEL_BORDER;

export const panelShellSx = {
  width: "100%",
  maxWidth: "100vw",
  minHeight: "100vh",
  display: "flex",
  bgcolor: PANEL.pageBg,
  backgroundImage: PANEL.pageGradient,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundAttachment: "fixed",
  color: PANEL.text.primary,
  overflowX: "hidden",
};

export const panelMainColumnSx = {
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
  bgcolor: "transparent",
};

export const panelMainSx = {
  flexGrow: 1,
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
  px: { xs: 2, md: 3, lg: 4 },
  py: { xs: 3, md: 4 },
  bgcolor: "transparent",
};

/** PanelLayout içerik alanı — düzen boşlukları; zemin rengi layout'tan gelir */
export const panelContentSx = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
};

/**
 * PanelLayout içindeki analiz/araç sayfaları — ek yatay padding eklemez.
 * Girinti tek kaynaktan gelir: panelMainSx (PanelLayout).
 * Referans: İstatistiksel Analiz sayfası.
 */
export const panelInnerPageShellSx = {
  width: "100%",
  minHeight: "100%",
  display: "flex",
  flexDirection: "column",
  bgcolor: "transparent",
  color: PANEL.text.primary,
  boxSizing: "border-box",
  pb: { xs: 1, md: 2 },
};

/** Ortalanmış form sayfaları — tam genişlik, viewport'a sığar */
export const panelFormPageContentSx = {
  ...panelContentSx,
  alignItems: "stretch",
  py: { xs: 1.5, md: 2 },
  px: { xs: 2, md: 3 },
  flex: 1,
  minHeight: 0,
  overflow: { xs: "auto", md: "hidden" },
};

/** @deprecated tenantPanelContentSx — geriye uyumluluk alias'ları */
export const tenantPanelShellSx = panelShellSx;
export const tenantPanelMainColumnSx = panelMainColumnSx;
export const tenantPanelMainSx = panelMainSx;
export const tenantPanelContentSx = panelContentSx;
export const tenantFormPageContentSx = panelFormPageContentSx;
